import { GetRoktTransactionAttributesArgs } from 'types/api/arguments/get-rokt-transaction-attributes-args'
import { GetRoktTransactionAttributesResp } from 'types/api/response/get-rokt-transaction-attributes-resp'

import { api } from './api'

export const getRoktTransactionsAttributes = ({
  transactionId,
}: GetRoktTransactionAttributesArgs) =>
  api.get<GetRoktTransactionAttributesResp>(
    `/ads/rokt?transaction_id=${transactionId}&cart_items=true`,
  )
